import React from "react";
import { ShimmerLine } from "../../../components/Shimmer/ShimmerLine/ShimmerLine";
import { SlotStack, SlotStackItem } from "../../../components/Stacks/SlotStack/SlotStack";
import { Stack } from "../../../components/Stacks/Stack/Stack";
import { ViewportType } from "../../../shared/constants";
import { useViewport } from "../../../styles";

const lineWidth = 120;
const lineHeight = 12;
const defaultListItemHeight = "48px";
const defaultListItemPadding = "0px 0px 0px 42px";

export const LimitListItemShimmer: React.FC = () => {
    const viewportType: ViewportType = useViewport();
    // tslint:disable-next-line: no-magic-numbers
    const totalSlots = viewportType === "l" ? 9 : 12;
    if (viewportType === "s") {
        return (
            <Stack
                verticalAlign="center"
                childrenGap="8px"
                backgroundColor="neutralMed"
                height={defaultListItemHeight}
                padding={defaultListItemPadding}
            >
                <ShimmerLine width={lineWidth} height={lineHeight} />
                <ShimmerLine width={lineWidth} height={lineHeight} />
            </Stack>
        );
    } else if (viewportType === "m") {
        return (
            <SlotStack
                backgroundColor="neutralMed"
                height={defaultListItemHeight}
                padding={defaultListItemPadding}
                totalSlots={totalSlots}
                verticalAlign="center"
            >
                <SlotStackItem slots={6}>
                    <ShimmerLine width={lineWidth} height={lineHeight} />
                </SlotStackItem>
                <SlotStackItem slots={6}>
                    <ShimmerLine width={lineWidth} height={lineHeight} />
                </SlotStackItem>
            </SlotStack>
        );
    }
    // tslint:disable-next-line: no-magic-numbers
    const slotSize = viewportType === "l" ? 3 : 6;
    return (
        <SlotStack
            backgroundColor="neutralMed"
            height={defaultListItemHeight}
            padding={defaultListItemPadding}
            totalSlots={totalSlots}
            verticalAlign="center"
        >
            <SlotStackItem slots={slotSize}>
                <ShimmerLine width={lineWidth} height={lineHeight} />
            </SlotStackItem>
            <SlotStackItem slots={3}>
                <ShimmerLine width={lineWidth} height={lineHeight} />
            </SlotStackItem>
            <SlotStackItem slots={3}>
                <ShimmerLine width={lineWidth} height={lineHeight} />
            </SlotStackItem>
        </SlotStack>
    );
};
